exports = module.exports = require("../../../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@media (orientation:landscape){html[onsflag-iphonex-landscape] .page__content{padding-left:var(--iphonex-safe-area-inset-left-landscape);padding-right:var(--iphonex-safe-area-inset-right-landscape)}html[onsflag-iphonex-landscape] .dialog .page__content,html[onsflag-iphonex-landscape] .modal .page__content{padding-left:0;padding-right:0}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/onsenui/css-components-src/src/iphonex-support/page.css
// module id = 354
// module chunks = 1